import DataManager from './data-manager';
import ProftestScreen from './proftest-screen';
import ResultScreen from "./result-screen";
import ServiceLocator from "../../../../global/service-locator";

export default class ProfTest {
	constructor() {
		this.sl = ServiceLocator.instance;

		this.currentView = 0;

		this.dataManager = new DataManager();
		this.proftestScreen = new ProftestScreen();
		this.resultScreen = new ResultScreen();

		this.completeTestSubscription = null;
		this.newTestSubscription = null;

		this.init();
	}

	init() {
		this.dataManager.fetch()
			.then(() => {
				if (this.sl.headerLoaded) {
					this.bootstrap();
				} else {
					this.sl.eventEmitterService.subscribe('event:header-loaded', () => {
						this.bootstrap();
					});
				}
			});
	}

	bootstrap() {
		if (this.checkHash()) {
			this.initResultScreen();
		} else {
			this.initWelcomeScreen();
		}
	}

	initWelcomeScreen() {
		document.body.classList.add('-welcome-screen');

		const $startTrigger = document.getElementById('proftestStart');
		$startTrigger.addEventListener('click', () => {
			this.initTestScreen();
		});
	}

	initTestScreen() {
		if (this.completeTestSubscription) {
			this.completeTestSubscription.unsubscribe();
		}

		document.body.classList.remove('-welcome-screen');
		document.body.classList.remove('-result-screen');
		document.body.classList.add('-proftest-screen');

		this.proftestScreen.init(this.dataManager);
		window.scrollTo(0, 0);

		/* @var detail: Test results */
		this.completeTestSubscription = this.proftestScreen.subscribe('completeTest', () => {
			window.location.hash = this.dataManager.generateHash();
			this.initResultScreen();
		});
	}

	initResultScreen() {
		if (this.newTestSubscription) {
			this.newTestSubscription.unsubscribe();
		}

		document.body.classList.remove('-welcome-screen');
		document.body.classList.remove('-proftest-screen');
		document.body.classList.add('-result-screen');

		this.resultScreen.init(this.dataManager);
		window.scrollTo(0, 0);

		this.newTestSubscription = this.resultScreen.subscribe('startNewTest', () => {
			this.initTestScreen();
		});
	}

	checkHash() {
		const hash = window.location.hash;
		return (/^#res?.+/).test(hash);
	}
}
